import { useState, useEffect } from "react";
import {
  Tooltip,
  Typography,
  Box,
  IconButton,
  InputBase,
  Divider,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseRelatedProduct } from "./UseRelatedProduct";
import { useNavigate, useLocation } from "react-router-dom";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import AddProductRelated from "./AddRelatedProduct";
import { UseMyPC } from "../../hooks/UseMyPC";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteRow from "../../components/DeleteRow";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import ProductRelatedDelete from "./ProductRelatedDelete";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";
import EditIcon from "@mui/icons-material/Edit";

export default function RelatedProductList() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const {
    getRelatedProductsList,
    deleteRelatedProducts,
    updateRelatedProducts,
  } = UseRelatedProduct();

  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("relatedProductID");
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });

  const [state, setState] = useState({
    id: undefined,
    onlyADV: undefined,
  });

  const [productRes, setProductRes] = useState();
  const [progress, setProgress] = useRecoilState(rsProgress);

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getRelatedProductsList(
      myPc,
      search,
      (products) => {
        setProductRes(products);
      },
      true
    );
  }, [myPc]);

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }
  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "productID",
      width: 85,
      align: "center",
      headerName: "کد محصول",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "productName",
      headerName: "محصول",
      width: 180,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.productName}
          </Typography>
        );
      },
    },

    {
      field: "relatedProductID",
      headerName: "کد",
      width: 80,
      align: "center",
      sortable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "relatedProductName",
      headerName: "محصول مرتبط",
      width: 180,
      align: "center",
      sortable: false,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.relatedProductName}
          </Typography>
        );
      },
    },
    {
      field: "shamsiExpireDate",
      headerName: "انقضا",
      width: 100,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.shamsiExpireDate}
          </Typography>
        );
      },
    },
    {
      field: "typeTitle",
      sortable: false,
      headerName: "نوع",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.typeTitle}
          </Typography>
        );
      },
    },
    {
      field: "onlyADV",
      width: 120,
      align: "center",
      headerName: "نمایش اتوماتیک",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="span"
              sx={{
                width: "100%",
                textAlign: "center",
                whiteSpace: "normal",
                mr: 1,
              }}
            >
              {!cellValues.row.onlyADV ? "فعال" : "غیرفعال"}
            </Typography>
            <IconButton
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
              onClick={() => {
                setState({
                  id: cellValues.row.id,
                  onlyADV: !cellValues.row.onlyADV,
                });
                setCheckState({
                  show: true,
                  name: "آیا از تغییر نمایش اتوماتیک محصولات اطمینان دارید ؟",
                });
              }}
            >
              <EditIcon fontSize="small" color="secondary" />
            </IconButton>
          </Box>
        );
      },
    },
    {
      field: "حذف",
      sortable: false,
      width: 70,
      headerAlign: "center",
      align: "center",
      headerName: "حذف",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.productName,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "محصولات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/relatedproducts" }],
      }}
    >
      <Box sx={{ height: "30rem", mb: 3 }}>
        {productRes ? (
          <DataGrid
            className="ltr-grid"
            disableVirtualization
            localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
            columns={columns}
            pageSize={productRes.pageCondition.pageCount}
            paginationMode="server"
            page={productRes.pageCondition.page - 1}
            rows={productRes.products}
            Pagination
            onPageChange={(page) => {
              updatePage(page + 1);
            }}
            rowCount={
              productRes?.pageCondition.totalItemCount
                ? productRes.pageCondition.totalItemCount
                : 1
            }
            enableRangeSelection={true}
            disableColumnMenu
            hideFooterSelectedRowCount
            components={{
              Pagination: CustomPagination,
            }}
            componentsProps={{
              pagination: {
                isLtr: true,
                nofab: true,
                rowCount: productRes?.pageCondition.totalItemCount
                  ? productRes.pageCondition.totalItemCount
                  : "",
              },
            }}
            initialState={{
              sorting: {
                sortModel: [
                  {
                    field: deCapitalizeFirstLetter(myPc.sortColumn),
                    sort: deCapitalizeFirstLetter(myPc.sortOrder),
                  },
                ],
              },
              pagination: {
                page: myPc.page,
              },
            }}
            onSortModelChange={(model) => {
              updateSort(
                model[0].field,
                model[0].sort == "asc" ? "asc" : "desc"
              );
            }}
            sortingOrder={["desc", "asc"]}
            sortingMode="server"
          />
        ) : (
          <ProgressCom></ProgressCom>
        )}
      </Box>
      <AddProductRelated
        callback={() => {
          setProgress(true);
          refresh();
        }}
      />
      <ProductRelatedDelete
        callback={() => {
          setProgress(true);
          refresh();
        }}
      />
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"محصول مرتبط محصول"}
        callback={() => {
          setProgress(true);
          let model = {
            id: deleteState.id,
          };
          deleteRelatedProducts(model, () => {
            refresh();
          });
        }}
      ></DeleteRow>
      <YesOrNoDialoge
        addOrder
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          setProgress(true);
          updateRelatedProducts(state, () => {
            refresh();
          });
        }}
      />
    </Detail>
  );
}
